'use strict';

var Promise = global.Promise || require('promise-polyfill');

module.exports = Promise;



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/lib/promise.js
// module id = 86
// module chunks = 0